import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-serach-card',
  templateUrl: './serach-card.component.html',
  styleUrls: ['./serach-card.component.scss']
})
export class SerachCardComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
